// src/App.js
import React, { useState } from 'react';
import Header from './components/Header';
import SalesDeck from './components/SalesDeck';
import QuoteBuilder from './components/QuoteBuilder';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [view, setView] = useState('quote');

  return (
    <div className="App">
      <Header currentView={view} onViewChange={setView} />
      <div className="pt-16">
        {view === 'deck' ? (
          <SalesDeck onGetQuote={() => setView('quote')} />
        ) : (
          <QuoteBuilder onBack={() => setView('deck')} />
        )}
      </div>
      <ToastContainer 
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;